document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.card-wrapper').forEach(function(wrapper) {
    wrapper.style.cursor = 'pointer';
    
    var touchStartX, touchStartY;
    
    wrapper.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    wrapper.addEventListener('touchend', function(e) {
      var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
      var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dx < 10 && dy < 10) {
        var link = this.querySelector('a[href]');
        if (link) window.location.href = link.href;
      }
    }, { passive: true });
  });
});

